type InnerCamelizeKey<T extends string> = T extends `${infer A}_${infer B}`
  ? `${Capitalize<A>}${InnerCamelizeKey<B>}`
  : Capitalize<T>
type CamelizeKey<T extends string> = T extends `${infer A}_${infer B}` ? `${A}${InnerCamelizeKey<B>}` : T
type CamelizeAnyKey<T> = T extends string ? CamelizeKey<T> : T
type CamelizeArray<T extends unknown[]> = T extends Array<infer TItem> ? Array<CamelizeObject<TItem>> : never
// eslint-disable-next-line @typescript-eslint/ban-types
type CamelizeObject<T> = T extends number | Function | string | boolean | symbol | null | undefined
  ? T
  : T extends unknown[]
    ? CamelizeArray<T>
    : {
        [TKey in keyof T as CamelizeAnyKey<TKey>]: CamelizeObject<T[TKey]>
      }

const isProxied = Symbol('isProxied')
interface ProxiedObject {
  [isProxied]: true
}

export function snakeToCamel<T>(obj: T): CamelizeObject<T> {
  if (!obj || typeof obj !== 'object') {
    return obj as CamelizeObject<T>
  }
  if ((obj as unknown as ProxiedObject)[isProxied]) {
    return obj as CamelizeObject<T>
  }
  if (Array.isArray(obj)) {
    // eslint-disable-next-line github/array-foreach
    obj.forEach((item, index) => (obj[index] = snakeToCamel(item)))
  } else {
    for (const [key, value] of Object.entries(obj)) {
      const newKey = key.replace(/_([a-z])/g, g => g[1]!.toUpperCase())
      if (value && typeof value === 'object') {
        snakeToCamel(value as Record<string, unknown>)
      }
      if (newKey !== key) {
        ;(obj as Record<string, unknown>)[newKey] = value
      }
    }
  }

  ;(obj as unknown as ProxiedObject)[isProxied] = true
  return obj as CamelizeObject<T>
}
